export const RULESETS = {
    '65LL': "65LL",
    SELECTION: "SEL_CDU",
};
export const TAGS = {
    'UI': "UI",
    'UI_SEL': "UI_SEL",
    'UI_SEL_REQ': "UI_SEL_REQ",
    'UI_SEL_REQ_REQS': "UI_SEL_REQ_REQS",
    'UI_SEL_REQ_INTG': "UI_SEL_REQ_INTG",
    'UI_SEL_REQ_PROD': "UI_SEL_REQ_PROD",
    'UI_CONFIG': "UI_CONFIG",
    'UI_CONFIG_RPT': "UI_CONFIG_RPT",
    'UI_SEL_DC': "UI_SEL_DC",
    'UI_SEL_DC_CONS': "UI_SEL_DC_CONS",
    'UI_SEL_DC_REQS': "UI_SEL_DC_REQS",
    'UI_ALWAYS': "UI_ALWAYS",
    'OPT_CAT_CTRL': "OPT_CAT_CTRL",
    'UI_CONFIG_UNIT': "UI_CONFIG_UNIT",
    'UI_CONFIG_UNIT_OPT': "UI_CONFIG_UNIT_OPT",
    'OPT_CAT_ELEC': "OPT_CAT_ELEC",
    'OPT_CAT_INST': "OPT_CAT_INST",
    'OPT_CAT_INSUL': "OPT_CAT_INSUL",
    'OPT_CAT_PCKG': "OPT_CAT_PCKG",
    'OPT_CAT_PLBG': "OPT_CAT_PLBG",
    'OPT_CAT_FILT': "OPT_CAT_FILT",
    'PN': "PN",
};
export const RULES = {
    [TAGS['UI']]: {
        BU_NBPHE: "BU_nBPHE",
        BU_SFREQZ: "BU_sFreqz",
        BU_SINTEGRATIONTYPE: "BU_sIntegrationType",
        BU_SMODEL: "BU_sModel",
        BU_SPRIMARYLOOPSTRAINER: "BU_sPrimaryLoopStrainer",
        BU_SSECONDLOOPFILTER: "BU_sSecondLoopFilter",
        BU_SUNITSIZE: "BU_sUnitSize",
        BU_SVOLTAGE: "BU_sVoltage",
        CALC_BPERFORMANCE: "Calc_bPerformance",
        DC_BLEAVINGAIRTECHLOOP: "DC_bLeavingAirTechLoop",
        DC_FENTERINGAIRTEMPFACILITYLOOP: "DC_fEnteringAirTempFacilityLoop",
        DC_FENTERINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringAirTempFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPFACILITYLOOP_UNIT: "DC_fEnteringAirTempFacilityLoop.UNIT",
        DC_FENTERINGAIRTEMPTECHLOOP: "DC_fEnteringAirTempTechLoop",
        DC_FENTERINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fEnteringAirTempTechLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPTECHLOOP_UNIT: "DC_fEnteringAirTempTechLoop.UNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP: "DC_fEnteringFluidFlowFacilityLoop",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fEnteringFluidFlowFacilityLoop.UNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP: "DC_fEnteringFluidFlowTechLoop",
        DC_FENTERINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowTechLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP_UNIT: "DC_fEnteringFluidFlowTechLoop.UNIT",
        DC_FFLUIDCONCFACILITYLOOP: "DC_fFluidConcFacilityLoop",
        DC_FFLUIDCONCFACILITYLOOP_DISPLAYUNIT: "DC_fFluidConcFacilityLoop.DISPLAYUNIT",
        DC_FFLUIDCONCFACILITYLOOP_UNIT: "DC_fFluidConcFacilityLoop.UNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP: "DC_fFluidConcTechnologyLoop",
        DC_FFLUIDCONCTECHNOLOGYLOOP_DISPLAYUNIT: "DC_fFluidConcTechnologyLoop.DISPLAYUNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP_UNIT: "DC_fFluidConcTechnologyLoop.UNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP: "DC_fLeavingAirTempFacilityLoop",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingAirTempFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_UNIT: "DC_fLeavingAirTempFacilityLoop.UNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP: "DC_fLeavingAirTempTechLoop",
        DC_FLEAVINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fLeavingAirTempTechLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP_UNIT: "DC_fLeavingAirTempTechLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP: "DC_fLeavingFluidFlowFacilityLoop",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fLeavingFluidFlowFacilityLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP: "DC_fLeavingFluidFlowTechLoop",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowTechLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_UNIT: "DC_fLeavingFluidFlowTechLoop.UNIT",
        DC_FMINFLOWRATEPERCAPACITY: "DC_fMinFlowRatePerCapacity",
        DC_FMINFLOWRATEPERCAPACITY_DISPLAYUNIT: "DC_fMinFlowRatePerCapacity.DISPLAYUNIT",
        DC_FMINFLOWRATEPERCAPACITY_UNIT: "DC_fMinFlowRatePerCapacity.UNIT",
        DC_ICDUREFERENCE: "DC_iCDUReference",
        DC_NALTITUDE: "DC_nAltitude",
        DC_NALTITUDE_DISPLAYUNIT: "DC_nAltitude.DISPLAYUNIT",
        DC_NALTITUDE_UNIT: "DC_nAltitude.UNIT",
        DC_NMAXPRESSUREDROP: "DC_nMaxPressureDrop",
        DC_NMAXPRESSUREDROP_DISPLAYUNIT: "DC_nMaxPressureDrop.DISPLAYUNIT",
        DC_NMAXPRESSUREDROP_UNIT: "DC_nMaxPressureDrop.UNIT",
        DC_NMINCAPACITYMARGIN: "DC_nMinCapacityMargin",
        DC_NMINCAPACITYMARGIN_DISPLAYUNIT: "DC_nMinCapacityMargin.DISPLAYUNIT",
        DC_NMINCAPACITYMARGIN_UNIT: "DC_nMinCapacityMargin.UNIT",
        DC_NSTATICPRESSUREDROP: "DC_nStaticPressureDrop",
        DC_NSTATICPRESSUREDROP_DISPLAYUNIT: "DC_nStaticPressureDrop.DISPLAYUNIT",
        DC_NSTATICPRESSUREDROP_UNIT: "DC_nStaticPressureDrop.UNIT",
        DC_NTARGETCAPACITY: "DC_nTargetCapacity",
        DC_NTARGETCAPACITY_DISPLAYUNIT: "DC_nTargetCapacity.DISPLAYUNIT",
        DC_NTARGETCAPACITY_UNIT: "DC_nTargetCapacity.UNIT",
        DC_SENTERINGAIRFACILITYLOOP: "DC_sEnteringAirFacilityLoop",
        DC_SENTERINGAIRTECHLOOP: "DC_sEnteringAirTechLoop",
        DC_SFLUIDTYPEFACILITYLOOP: "DC_sFluidTypeFacilityLoop",
        DC_SFLUIDTYPETECHLOOP: "DC_sFluidTypeTechLoop",
        DC_SLEAVINGAIRFACILITYLOOP: "DC_sLeavingAirFacilityLoop",
        DC_SLEAVINGAIRTECHLOOP: "DC_sLeavingAirTechLoop",
        MLP_FBASEUNIT: "MLP_fBaseUnit",
        MLP_FTOTAL: "MLP_fTotal",
        MLP_OPT_FTOTAL: "MLP_Opt_fTotal",
        OPT_BCON11A_EXTRASENSORREDUNDANCY: "Opt_bCON11A_ExtraSensorRedundancy",
        OPT_BCON11B_ENERGYMANAGEMENT: "Opt_bCON11B_EnergyManagement",
        OPT_BCON13A_STANDARHMIUPS: "Opt_bCON13A_StandarHMIUPS",
        OPT_BCON13B_REMOTECONNECTIVITYGFCI: "Opt_bCON13B_RemoteConnectivityGFCI",
        OPT_BELT09_AUTOMATICTRANSFERSWITCH: "Opt_bELT09_AutomaticTransferSwitch",
        OPT_BELT10_LOWHARMONICFILTER: "Opt_bELT10_LowHarmonicFilter",
        OPT_BINS12A_EXTERNALDOORLOCKS: "Opt_bINS12A_ExternalDoorLocks",
        OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION: "Opt_bINS12B_AlternateHMIMountingLocation",
        OPT_BINS14_SEISMICOPTIONKIT: "Opt_bINS14_SeismicOptionKit",
        OPT_BISL05_FWSPLUMBINGINSULATION: "Opt_bISL05_FWSPlumbingInsulation",
        OPT_BPAC15A_SKIDSNBAG: "Opt_bPAC15A_SkidsNBag",
        OPT_BPAC15B_SHIPWITHCASTERS: "Opt_bPAC15B_ShipWithCasters",
        OPT_BPAC15C_PADS: "Opt_bPAC15C_Pads",
        OPT_BPLM01C_ALTERNATEFLOWMETER: "Opt_bPLM01C_AlternateFlowmeter",
        OPT_SCATEGORY: "Opt_sCategory",
        OPT_SELT06_VOLTAGE: "Opt_sELT06_Voltage",
        OPT_SELT07_POWERDISCONNECT: "Opt_sELT07_PowerDisconnect",
        OPT_SELT08_SCCR: "Opt_sELT08_SCCR",
        OPT_SFIL03_STRAINER: "Opt_sFIL03_Strainer",
        OPT_SFIL04_TCSFILTER: "Opt_sFIL04_TCSFilter",
        OPT_SINS02A_TCSFILLPUMP: "Opt_sINS02A_TCSFillPump",
        OPT_SINS02B_EXPANSIONTANKS: "Opt_sINS02B_ExpansionTanks",
        OPT_SINS06_PUMP: "Opt_sINS06_Pump",
        OPT_SPAC01_CHASSIS: "Opt_sPAC01_Chassis",
        OPT_SPLM01A_FACILITYFWSCONNECTION: "Opt_sPLM01A_FacilityFWSConnection",
        OPT_SPLM01B_TECHNOLOGYCONNECTION: "Opt_sPLM01B_TechnologyConnection",
        PN_SMODEL: "PN_sModel",
        REPORT_BPERFORMANCE: "Report_bPerformance",
        TAG_BVALID: "Tag_bValid",
        TAG_NQTY: "Tag_nQty",
        TAG_SCONFIGRULESET: "Tag_sConfigRuleset",
        UI_CONFIG_UNIT_OPT_VALID: "UI_CONFIG_UNIT_OPT.VALID",
        UI_CONFIG_UNIT_VALID: "UI_CONFIG_UNIT.VALID",
        UI_CONFIG_VALID: "UI_CONFIG.VALID",
        UI_SEL_DC_CONS_VALID: "UI_SEL_DC_CONS.VALID",
        UI_SEL_DC_REQS_VALID: "UI_SEL_DC_REQS.VALID",
        UI_SEL_DC_VALID: "UI_SEL_DC.VALID",
        UI_SEL_REQ_INTG_VALID: "UI_SEL_REQ_INTG.VALID",
        UI_SEL_REQ_PROD_VALID: "UI_SEL_REQ_PROD.VALID",
        UI_SEL_REQ_REQS_VALID: "UI_SEL_REQ_REQS.VALID",
        UI_SEL_REQ_VALID: "UI_SEL_REQ.VALID",
        UI_SEL_VALID: "UI_SEL.VALID",
    },
    [TAGS['UI_SEL']]: {
        BU_NBPHE: "BU_nBPHE",
        BU_SFREQZ: "BU_sFreqz",
        BU_SINTEGRATIONTYPE: "BU_sIntegrationType",
        BU_SMODEL: "BU_sModel",
        BU_SPRIMARYLOOPSTRAINER: "BU_sPrimaryLoopStrainer",
        BU_SSECONDLOOPFILTER: "BU_sSecondLoopFilter",
        BU_SUNITSIZE: "BU_sUnitSize",
        BU_SVOLTAGE: "BU_sVoltage",
    },
    [TAGS['UI_SEL_REQ']]: {
        BU_NBPHE: "BU_nBPHE",
        BU_SFREQZ: "BU_sFreqz",
        BU_SINTEGRATIONTYPE: "BU_sIntegrationType",
        BU_SMODEL: "BU_sModel",
        BU_SPRIMARYLOOPSTRAINER: "BU_sPrimaryLoopStrainer",
        BU_SSECONDLOOPFILTER: "BU_sSecondLoopFilter",
        BU_SUNITSIZE: "BU_sUnitSize",
        BU_SVOLTAGE: "BU_sVoltage",
    },
    [TAGS['UI_SEL_REQ_REQS']]: {
        BU_NBPHE: "BU_nBPHE",
        BU_SFREQZ: "BU_sFreqz",
        BU_SPRIMARYLOOPSTRAINER: "BU_sPrimaryLoopStrainer",
        BU_SSECONDLOOPFILTER: "BU_sSecondLoopFilter",
        BU_SUNITSIZE: "BU_sUnitSize",
        BU_SVOLTAGE: "BU_sVoltage",
    },
    [TAGS['UI_SEL_REQ_INTG']]: {
        BU_SINTEGRATIONTYPE: "BU_sIntegrationType",
    },
    [TAGS['UI_SEL_REQ_PROD']]: {
        BU_SMODEL: "BU_sModel",
    },
    [TAGS['UI_CONFIG']]: {
        CALC_BPERFORMANCE: "Calc_bPerformance",
        OPT_BCON11A_EXTRASENSORREDUNDANCY: "Opt_bCON11A_ExtraSensorRedundancy",
        OPT_BCON11B_ENERGYMANAGEMENT: "Opt_bCON11B_EnergyManagement",
        OPT_BCON13A_STANDARHMIUPS: "Opt_bCON13A_StandarHMIUPS",
        OPT_BCON13B_REMOTECONNECTIVITYGFCI: "Opt_bCON13B_RemoteConnectivityGFCI",
        OPT_BELT09_AUTOMATICTRANSFERSWITCH: "Opt_bELT09_AutomaticTransferSwitch",
        OPT_BELT10_LOWHARMONICFILTER: "Opt_bELT10_LowHarmonicFilter",
        OPT_BINS12A_EXTERNALDOORLOCKS: "Opt_bINS12A_ExternalDoorLocks",
        OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION: "Opt_bINS12B_AlternateHMIMountingLocation",
        OPT_BINS14_SEISMICOPTIONKIT: "Opt_bINS14_SeismicOptionKit",
        OPT_BISL05_FWSPLUMBINGINSULATION: "Opt_bISL05_FWSPlumbingInsulation",
        OPT_BPAC15A_SKIDSNBAG: "Opt_bPAC15A_SkidsNBag",
        OPT_BPAC15B_SHIPWITHCASTERS: "Opt_bPAC15B_ShipWithCasters",
        OPT_BPAC15C_PADS: "Opt_bPAC15C_Pads",
        OPT_BPLM01C_ALTERNATEFLOWMETER: "Opt_bPLM01C_AlternateFlowmeter",
        OPT_SCATEGORY: "Opt_sCategory",
        OPT_SELT06_VOLTAGE: "Opt_sELT06_Voltage",
        OPT_SELT07_POWERDISCONNECT: "Opt_sELT07_PowerDisconnect",
        OPT_SELT08_SCCR: "Opt_sELT08_SCCR",
        OPT_SFIL03_STRAINER: "Opt_sFIL03_Strainer",
        OPT_SFIL04_TCSFILTER: "Opt_sFIL04_TCSFilter",
        OPT_SINS02A_TCSFILLPUMP: "Opt_sINS02A_TCSFillPump",
        OPT_SINS02B_EXPANSIONTANKS: "Opt_sINS02B_ExpansionTanks",
        OPT_SINS06_PUMP: "Opt_sINS06_Pump",
        OPT_SPAC01_CHASSIS: "Opt_sPAC01_Chassis",
        OPT_SPLM01A_FACILITYFWSCONNECTION: "Opt_sPLM01A_FacilityFWSConnection",
        OPT_SPLM01B_TECHNOLOGYCONNECTION: "Opt_sPLM01B_TechnologyConnection",
    },
    [TAGS['UI_CONFIG_RPT']]: {
        CALC_BPERFORMANCE: "Calc_bPerformance",
        REPORT_BPERFORMANCE: "Report_bPerformance",
    },
    [TAGS['UI_SEL_DC']]: {
        DC_BLEAVINGAIRTECHLOOP: "DC_bLeavingAirTechLoop",
        DC_FENTERINGAIRTEMPFACILITYLOOP: "DC_fEnteringAirTempFacilityLoop",
        DC_FENTERINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringAirTempFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPFACILITYLOOP_UNIT: "DC_fEnteringAirTempFacilityLoop.UNIT",
        DC_FENTERINGAIRTEMPTECHLOOP: "DC_fEnteringAirTempTechLoop",
        DC_FENTERINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fEnteringAirTempTechLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPTECHLOOP_UNIT: "DC_fEnteringAirTempTechLoop.UNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP: "DC_fEnteringFluidFlowFacilityLoop",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fEnteringFluidFlowFacilityLoop.UNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP: "DC_fEnteringFluidFlowTechLoop",
        DC_FENTERINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowTechLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP_UNIT: "DC_fEnteringFluidFlowTechLoop.UNIT",
        DC_FFLUIDCONCFACILITYLOOP: "DC_fFluidConcFacilityLoop",
        DC_FFLUIDCONCFACILITYLOOP_DISPLAYUNIT: "DC_fFluidConcFacilityLoop.DISPLAYUNIT",
        DC_FFLUIDCONCFACILITYLOOP_UNIT: "DC_fFluidConcFacilityLoop.UNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP: "DC_fFluidConcTechnologyLoop",
        DC_FFLUIDCONCTECHNOLOGYLOOP_DISPLAYUNIT: "DC_fFluidConcTechnologyLoop.DISPLAYUNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP_UNIT: "DC_fFluidConcTechnologyLoop.UNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP: "DC_fLeavingAirTempFacilityLoop",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingAirTempFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_UNIT: "DC_fLeavingAirTempFacilityLoop.UNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP: "DC_fLeavingAirTempTechLoop",
        DC_FLEAVINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fLeavingAirTempTechLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP_UNIT: "DC_fLeavingAirTempTechLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP: "DC_fLeavingFluidFlowFacilityLoop",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fLeavingFluidFlowFacilityLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP: "DC_fLeavingFluidFlowTechLoop",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowTechLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_UNIT: "DC_fLeavingFluidFlowTechLoop.UNIT",
        DC_FMINFLOWRATEPERCAPACITY: "DC_fMinFlowRatePerCapacity",
        DC_FMINFLOWRATEPERCAPACITY_DISPLAYUNIT: "DC_fMinFlowRatePerCapacity.DISPLAYUNIT",
        DC_FMINFLOWRATEPERCAPACITY_UNIT: "DC_fMinFlowRatePerCapacity.UNIT",
        DC_ICDUREFERENCE: "DC_iCDUReference",
        DC_NALTITUDE: "DC_nAltitude",
        DC_NALTITUDE_DISPLAYUNIT: "DC_nAltitude.DISPLAYUNIT",
        DC_NALTITUDE_UNIT: "DC_nAltitude.UNIT",
        DC_NMAXPRESSUREDROP: "DC_nMaxPressureDrop",
        DC_NMAXPRESSUREDROP_DISPLAYUNIT: "DC_nMaxPressureDrop.DISPLAYUNIT",
        DC_NMAXPRESSUREDROP_UNIT: "DC_nMaxPressureDrop.UNIT",
        DC_NMINCAPACITYMARGIN: "DC_nMinCapacityMargin",
        DC_NMINCAPACITYMARGIN_DISPLAYUNIT: "DC_nMinCapacityMargin.DISPLAYUNIT",
        DC_NMINCAPACITYMARGIN_UNIT: "DC_nMinCapacityMargin.UNIT",
        DC_NSTATICPRESSUREDROP: "DC_nStaticPressureDrop",
        DC_NSTATICPRESSUREDROP_DISPLAYUNIT: "DC_nStaticPressureDrop.DISPLAYUNIT",
        DC_NSTATICPRESSUREDROP_UNIT: "DC_nStaticPressureDrop.UNIT",
        DC_NTARGETCAPACITY: "DC_nTargetCapacity",
        DC_NTARGETCAPACITY_DISPLAYUNIT: "DC_nTargetCapacity.DISPLAYUNIT",
        DC_NTARGETCAPACITY_UNIT: "DC_nTargetCapacity.UNIT",
        DC_SENTERINGAIRFACILITYLOOP: "DC_sEnteringAirFacilityLoop",
        DC_SENTERINGAIRTECHLOOP: "DC_sEnteringAirTechLoop",
        DC_SFLUIDTYPEFACILITYLOOP: "DC_sFluidTypeFacilityLoop",
        DC_SFLUIDTYPETECHLOOP: "DC_sFluidTypeTechLoop",
        DC_SLEAVINGAIRFACILITYLOOP: "DC_sLeavingAirFacilityLoop",
        DC_SLEAVINGAIRTECHLOOP: "DC_sLeavingAirTechLoop",
    },
    [TAGS['UI_SEL_DC_CONS']]: {
        DC_FENTERINGAIRTEMPFACILITYLOOP: "DC_fEnteringAirTempFacilityLoop",
        DC_FENTERINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringAirTempFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPFACILITYLOOP_UNIT: "DC_fEnteringAirTempFacilityLoop.UNIT",
        DC_FENTERINGAIRTEMPTECHLOOP: "DC_fEnteringAirTempTechLoop",
        DC_FENTERINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fEnteringAirTempTechLoop.DISPLAYUNIT",
        DC_FENTERINGAIRTEMPTECHLOOP_UNIT: "DC_fEnteringAirTempTechLoop.UNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP: "DC_fEnteringFluidFlowFacilityLoop",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fEnteringFluidFlowFacilityLoop.UNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP: "DC_fEnteringFluidFlowTechLoop",
        DC_FENTERINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fEnteringFluidFlowTechLoop.DISPLAYUNIT",
        DC_FENTERINGFLUIDFLOWTECHLOOP_UNIT: "DC_fEnteringFluidFlowTechLoop.UNIT",
        DC_FFLUIDCONCFACILITYLOOP: "DC_fFluidConcFacilityLoop",
        DC_FFLUIDCONCFACILITYLOOP_DISPLAYUNIT: "DC_fFluidConcFacilityLoop.DISPLAYUNIT",
        DC_FFLUIDCONCFACILITYLOOP_UNIT: "DC_fFluidConcFacilityLoop.UNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP: "DC_fFluidConcTechnologyLoop",
        DC_FFLUIDCONCTECHNOLOGYLOOP_DISPLAYUNIT: "DC_fFluidConcTechnologyLoop.DISPLAYUNIT",
        DC_FFLUIDCONCTECHNOLOGYLOOP_UNIT: "DC_fFluidConcTechnologyLoop.UNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP: "DC_fLeavingAirTempFacilityLoop",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingAirTempFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPFACILITYLOOP_UNIT: "DC_fLeavingAirTempFacilityLoop.UNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP: "DC_fLeavingAirTempTechLoop",
        DC_FLEAVINGAIRTEMPTECHLOOP_DISPLAYUNIT: "DC_fLeavingAirTempTechLoop.DISPLAYUNIT",
        DC_FLEAVINGAIRTEMPTECHLOOP_UNIT: "DC_fLeavingAirTempTechLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP: "DC_fLeavingFluidFlowFacilityLoop",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowFacilityLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWFACILITYLOOP_UNIT: "DC_fLeavingFluidFlowFacilityLoop.UNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP: "DC_fLeavingFluidFlowTechLoop",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_DISPLAYUNIT: "DC_fLeavingFluidFlowTechLoop.DISPLAYUNIT",
        DC_FLEAVINGFLUIDFLOWTECHLOOP_UNIT: "DC_fLeavingFluidFlowTechLoop.UNIT",
        DC_ICDUREFERENCE: "DC_iCDUReference",
        DC_NALTITUDE: "DC_nAltitude",
        DC_NALTITUDE_DISPLAYUNIT: "DC_nAltitude.DISPLAYUNIT",
        DC_NALTITUDE_UNIT: "DC_nAltitude.UNIT",
        DC_NMAXPRESSUREDROP: "DC_nMaxPressureDrop",
        DC_NMAXPRESSUREDROP_DISPLAYUNIT: "DC_nMaxPressureDrop.DISPLAYUNIT",
        DC_NMAXPRESSUREDROP_UNIT: "DC_nMaxPressureDrop.UNIT",
        DC_NSTATICPRESSUREDROP: "DC_nStaticPressureDrop",
        DC_NSTATICPRESSUREDROP_DISPLAYUNIT: "DC_nStaticPressureDrop.DISPLAYUNIT",
        DC_NSTATICPRESSUREDROP_UNIT: "DC_nStaticPressureDrop.UNIT",
        DC_SENTERINGAIRFACILITYLOOP: "DC_sEnteringAirFacilityLoop",
        DC_SENTERINGAIRTECHLOOP: "DC_sEnteringAirTechLoop",
        DC_SFLUIDTYPEFACILITYLOOP: "DC_sFluidTypeFacilityLoop",
        DC_SFLUIDTYPETECHLOOP: "DC_sFluidTypeTechLoop",
        DC_SLEAVINGAIRFACILITYLOOP: "DC_sLeavingAirFacilityLoop",
        DC_SLEAVINGAIRTECHLOOP: "DC_sLeavingAirTechLoop",
    },
    [TAGS['UI_SEL_DC_REQS']]: {
        DC_FMINFLOWRATEPERCAPACITY: "DC_fMinFlowRatePerCapacity",
        DC_FMINFLOWRATEPERCAPACITY_DISPLAYUNIT: "DC_fMinFlowRatePerCapacity.DISPLAYUNIT",
        DC_FMINFLOWRATEPERCAPACITY_UNIT: "DC_fMinFlowRatePerCapacity.UNIT",
        DC_NMINCAPACITYMARGIN: "DC_nMinCapacityMargin",
        DC_NMINCAPACITYMARGIN_DISPLAYUNIT: "DC_nMinCapacityMargin.DISPLAYUNIT",
        DC_NMINCAPACITYMARGIN_UNIT: "DC_nMinCapacityMargin.UNIT",
        DC_NTARGETCAPACITY: "DC_nTargetCapacity",
        DC_NTARGETCAPACITY_DISPLAYUNIT: "DC_nTargetCapacity.DISPLAYUNIT",
        DC_NTARGETCAPACITY_UNIT: "DC_nTargetCapacity.UNIT",
    },
    [TAGS['UI_ALWAYS']]: {
        MLP_FBASEUNIT: "MLP_fBaseUnit",
        MLP_FTOTAL: "MLP_fTotal",
        MLP_OPT_FTOTAL: "MLP_Opt_fTotal",
        PN_SMODEL: "PN_sModel",
        TAG_BVALID: "Tag_bValid",
        TAG_NQTY: "Tag_nQty",
        TAG_SCONFIGRULESET: "Tag_sConfigRuleset",
        UI_CONFIG_UNIT_OPT_VALID: "UI_CONFIG_UNIT_OPT.VALID",
        UI_CONFIG_UNIT_VALID: "UI_CONFIG_UNIT.VALID",
        UI_CONFIG_VALID: "UI_CONFIG.VALID",
        UI_SEL_DC_CONS_VALID: "UI_SEL_DC_CONS.VALID",
        UI_SEL_DC_REQS_VALID: "UI_SEL_DC_REQS.VALID",
        UI_SEL_DC_VALID: "UI_SEL_DC.VALID",
        UI_SEL_REQ_INTG_VALID: "UI_SEL_REQ_INTG.VALID",
        UI_SEL_REQ_PROD_VALID: "UI_SEL_REQ_PROD.VALID",
        UI_SEL_REQ_REQS_VALID: "UI_SEL_REQ_REQS.VALID",
        UI_SEL_REQ_VALID: "UI_SEL_REQ.VALID",
        UI_SEL_VALID: "UI_SEL.VALID",
    },
    [TAGS['OPT_CAT_CTRL']]: {
        OPT_BCON11A_EXTRASENSORREDUNDANCY: "Opt_bCON11A_ExtraSensorRedundancy",
        OPT_BCON11B_ENERGYMANAGEMENT: "Opt_bCON11B_EnergyManagement",
        OPT_BCON13A_STANDARHMIUPS: "Opt_bCON13A_StandarHMIUPS",
        OPT_BCON13B_REMOTECONNECTIVITYGFCI: "Opt_bCON13B_RemoteConnectivityGFCI",
    },
    [TAGS['UI_CONFIG_UNIT']]: {
        OPT_BCON11A_EXTRASENSORREDUNDANCY: "Opt_bCON11A_ExtraSensorRedundancy",
        OPT_BCON11B_ENERGYMANAGEMENT: "Opt_bCON11B_EnergyManagement",
        OPT_BCON13A_STANDARHMIUPS: "Opt_bCON13A_StandarHMIUPS",
        OPT_BCON13B_REMOTECONNECTIVITYGFCI: "Opt_bCON13B_RemoteConnectivityGFCI",
        OPT_BELT09_AUTOMATICTRANSFERSWITCH: "Opt_bELT09_AutomaticTransferSwitch",
        OPT_BELT10_LOWHARMONICFILTER: "Opt_bELT10_LowHarmonicFilter",
        OPT_BINS12A_EXTERNALDOORLOCKS: "Opt_bINS12A_ExternalDoorLocks",
        OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION: "Opt_bINS12B_AlternateHMIMountingLocation",
        OPT_BINS14_SEISMICOPTIONKIT: "Opt_bINS14_SeismicOptionKit",
        OPT_BISL05_FWSPLUMBINGINSULATION: "Opt_bISL05_FWSPlumbingInsulation",
        OPT_BPAC15A_SKIDSNBAG: "Opt_bPAC15A_SkidsNBag",
        OPT_BPAC15B_SHIPWITHCASTERS: "Opt_bPAC15B_ShipWithCasters",
        OPT_BPAC15C_PADS: "Opt_bPAC15C_Pads",
        OPT_BPLM01C_ALTERNATEFLOWMETER: "Opt_bPLM01C_AlternateFlowmeter",
        OPT_SCATEGORY: "Opt_sCategory",
        OPT_SELT06_VOLTAGE: "Opt_sELT06_Voltage",
        OPT_SELT07_POWERDISCONNECT: "Opt_sELT07_PowerDisconnect",
        OPT_SELT08_SCCR: "Opt_sELT08_SCCR",
        OPT_SFIL03_STRAINER: "Opt_sFIL03_Strainer",
        OPT_SFIL04_TCSFILTER: "Opt_sFIL04_TCSFilter",
        OPT_SINS02A_TCSFILLPUMP: "Opt_sINS02A_TCSFillPump",
        OPT_SINS02B_EXPANSIONTANKS: "Opt_sINS02B_ExpansionTanks",
        OPT_SINS06_PUMP: "Opt_sINS06_Pump",
        OPT_SPAC01_CHASSIS: "Opt_sPAC01_Chassis",
        OPT_SPLM01A_FACILITYFWSCONNECTION: "Opt_sPLM01A_FacilityFWSConnection",
        OPT_SPLM01B_TECHNOLOGYCONNECTION: "Opt_sPLM01B_TechnologyConnection",
    },
    [TAGS['UI_CONFIG_UNIT_OPT']]: {
        OPT_BCON11A_EXTRASENSORREDUNDANCY: "Opt_bCON11A_ExtraSensorRedundancy",
        OPT_BCON11B_ENERGYMANAGEMENT: "Opt_bCON11B_EnergyManagement",
        OPT_BCON13A_STANDARHMIUPS: "Opt_bCON13A_StandarHMIUPS",
        OPT_BCON13B_REMOTECONNECTIVITYGFCI: "Opt_bCON13B_RemoteConnectivityGFCI",
        OPT_BELT09_AUTOMATICTRANSFERSWITCH: "Opt_bELT09_AutomaticTransferSwitch",
        OPT_BELT10_LOWHARMONICFILTER: "Opt_bELT10_LowHarmonicFilter",
        OPT_BINS12A_EXTERNALDOORLOCKS: "Opt_bINS12A_ExternalDoorLocks",
        OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION: "Opt_bINS12B_AlternateHMIMountingLocation",
        OPT_BINS14_SEISMICOPTIONKIT: "Opt_bINS14_SeismicOptionKit",
        OPT_BISL05_FWSPLUMBINGINSULATION: "Opt_bISL05_FWSPlumbingInsulation",
        OPT_BPAC15A_SKIDSNBAG: "Opt_bPAC15A_SkidsNBag",
        OPT_BPAC15B_SHIPWITHCASTERS: "Opt_bPAC15B_ShipWithCasters",
        OPT_BPAC15C_PADS: "Opt_bPAC15C_Pads",
        OPT_BPLM01C_ALTERNATEFLOWMETER: "Opt_bPLM01C_AlternateFlowmeter",
        OPT_SCATEGORY: "Opt_sCategory",
        OPT_SELT06_VOLTAGE: "Opt_sELT06_Voltage",
        OPT_SELT07_POWERDISCONNECT: "Opt_sELT07_PowerDisconnect",
        OPT_SELT08_SCCR: "Opt_sELT08_SCCR",
        OPT_SFIL03_STRAINER: "Opt_sFIL03_Strainer",
        OPT_SFIL04_TCSFILTER: "Opt_sFIL04_TCSFilter",
        OPT_SINS02A_TCSFILLPUMP: "Opt_sINS02A_TCSFillPump",
        OPT_SINS02B_EXPANSIONTANKS: "Opt_sINS02B_ExpansionTanks",
        OPT_SINS06_PUMP: "Opt_sINS06_Pump",
        OPT_SPAC01_CHASSIS: "Opt_sPAC01_Chassis",
        OPT_SPLM01A_FACILITYFWSCONNECTION: "Opt_sPLM01A_FacilityFWSConnection",
        OPT_SPLM01B_TECHNOLOGYCONNECTION: "Opt_sPLM01B_TechnologyConnection",
    },
    [TAGS['OPT_CAT_ELEC']]: {
        OPT_BELT09_AUTOMATICTRANSFERSWITCH: "Opt_bELT09_AutomaticTransferSwitch",
        OPT_BELT10_LOWHARMONICFILTER: "Opt_bELT10_LowHarmonicFilter",
        OPT_SELT06_VOLTAGE: "Opt_sELT06_Voltage",
        OPT_SELT07_POWERDISCONNECT: "Opt_sELT07_PowerDisconnect",
        OPT_SELT08_SCCR: "Opt_sELT08_SCCR",
    },
    [TAGS['OPT_CAT_INST']]: {
        OPT_BINS12A_EXTERNALDOORLOCKS: "Opt_bINS12A_ExternalDoorLocks",
        OPT_BINS12B_ALTERNATEHMIMOUNTINGLOCATION: "Opt_bINS12B_AlternateHMIMountingLocation",
        OPT_BINS14_SEISMICOPTIONKIT: "Opt_bINS14_SeismicOptionKit",
        OPT_SINS02A_TCSFILLPUMP: "Opt_sINS02A_TCSFillPump",
        OPT_SINS02B_EXPANSIONTANKS: "Opt_sINS02B_ExpansionTanks",
        OPT_SINS06_PUMP: "Opt_sINS06_Pump",
    },
    [TAGS['OPT_CAT_INSUL']]: {
        OPT_BISL05_FWSPLUMBINGINSULATION: "Opt_bISL05_FWSPlumbingInsulation",
    },
    [TAGS['OPT_CAT_PCKG']]: {
        OPT_BPAC15A_SKIDSNBAG: "Opt_bPAC15A_SkidsNBag",
        OPT_BPAC15B_SHIPWITHCASTERS: "Opt_bPAC15B_ShipWithCasters",
        OPT_BPAC15C_PADS: "Opt_bPAC15C_Pads",
        OPT_SPAC01_CHASSIS: "Opt_sPAC01_Chassis",
    },
    [TAGS['OPT_CAT_PLBG']]: {
        OPT_BPLM01C_ALTERNATEFLOWMETER: "Opt_bPLM01C_AlternateFlowmeter",
        OPT_SPLM01A_FACILITYFWSCONNECTION: "Opt_sPLM01A_FacilityFWSConnection",
        OPT_SPLM01B_TECHNOLOGYCONNECTION: "Opt_sPLM01B_TechnologyConnection",
    },
    [TAGS['OPT_CAT_FILT']]: {
        OPT_SFIL03_STRAINER: "Opt_sFIL03_Strainer",
        OPT_SFIL04_TCSFILTER: "Opt_sFIL04_TCSFilter",
    },
    [TAGS['PN']]: {
        PN_SMODEL: "PN_sModel",
        PN_SMODEL_01: "PN_sModel.01",
        PN_SMODEL_02: "PN_sModel.02",
        PN_SMODEL_03: "PN_sModel.03",
        PN_SMODEL_04: "PN_sModel.04",
        PN_SMODEL_05: "PN_sModel.05",
        PN_SMODEL_06: "PN_sModel.06",
        PN_SMODEL_07: "PN_sModel.07",
        PN_SMODEL_08: "PN_sModel.08",
        PN_SMODEL_09: "PN_sModel.09",
        PN_SMODEL_10: "PN_sModel.10",
        PN_SMODEL_11: "PN_sModel.11",
        PN_SMODEL_12: "PN_sModel.12",
        PN_SMODEL_13: "PN_sModel.13",
        PN_SMODEL_14: "PN_sModel.14",
        PN_SMODEL_15: "PN_sModel.15",
        PN_SMODEL_16: "PN_sModel.16",
        PN_SMODEL_17: "PN_sModel.17",
        TAG_NQTY: "Tag_nQty",
    },
    UNTAGGED: {
        APPPERM_AMEA: "Appperm_AMEA",
        APPPERM_EU: "Appperm_EU",
        APPPERM_NAO: "Appperm_NAO",
        CALC_SCALCULATIONENGINE: "Calc_sCalculationEngine",
        CALC_SMAPPINGFILENAME: "Calc_sMappingFileName",
        CALC_BSELECTION: "Calc_bSelection",
        TAG_SRULESDATAVERSION: "Tag_sRulesDataVersion",
    },
};
